import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useLazyExportClientSetContactDetailsQuery } from "../../../services/campaignmanagement";
import { useClientSetContext } from "./ClientSetContext";

export const CommunicationPreferenceFilters = [
    { label: "Secure Client Website", value: "dashboard" },
    { label: "Mobile App", value: "mobile" },
    { label: "Messaging Contacts ", value: "messaging" },
    { label: "Email Notifications", value: "emailNotifications" },
    { label: "Email Market Updates", value: "emailMarketUpdates" },
    { label: "Email Marketing", value: "emailMarketing" },
];

export const ContactExportOptions = [
    // Contact Types
    { label: "Landline", value: 0 },
    { label: "Mobile", value: 1 },
    { label: "Email", value: 2 },
    { label: "Fax", value: 3 },
    { label: "Restricted Email", value: 4 },

    // Other Contact Details to be exported
    { label: "Address", value: 5 },
    { label: "Addressee", value: 6 },
    { label: "Salutation (Adviser)", value: 7 },
    { label: "Salutation (Formal)", value: 8 }
];

export const EmailExportOptions = [
    { label: "Default", value: 0 },
    { label: "Notifications Recipients", value: 1 },
    { label: "Market Updates Recipients", value: 2 },
    { label: "Marketing Recipients", value: 3 }
]

const defaultValues = {
    serviceLevelAgreementIds: [],
    filters: [],
    contactDetails: [],
    emails: []
};

const useExportContactDetails = ({ isEmailExport, onHide }) => {
    const { selectedSetId } = useClientSetContext();

    const { control, setValue, handleSubmit, reset } = useForm({ defaultValues });

    const [exportTrigger] = useLazyExportClientSetContactDetailsQuery();

    const requestFromForm = (data) => {
        // Convert the [string] required preferences array into a {string: boolean} object
        const filters = Object.fromEntries(CommunicationPreferenceFilters.map((filter) => [filter.value, data.filters.includes(filter.value)]));

        return {
            filters,
            exportProjection: isEmailExport ? data.emails : data.contactDetails,
        }
    }

    const onSubmit = (data) => {
        onHide();

        const request = {
            clientSetId: selectedSetId,
            isEmailExport,
            ...requestFromForm(data),
        }

        return toast.promise(exportTrigger(request).unwrap(), {
            loading: "Exporting...",
            success: (res) => {
                const { blob, filename } = res;
                const url = window.URL.createObjectURL(blob);

                // Create a temporary link to trigger the download with set filename
                const tempAnchor = document.createElement('a');
                tempAnchor.href = url;
                tempAnchor.download = filename;
                document.body.appendChild(tempAnchor);
                tempAnchor.click();

                // Clean up the URL object
                document.body.removeChild(tempAnchor);
                window.URL.revokeObjectURL(url);
            },
            error: (err) => console.error(err) || "Failed to export."
        }).finally(() => reset(defaultValues));
    }

    const onCancel = () => {
        reset(defaultValues);
        onHide();
    }

    return {
        control,
        setValue,
        onCancel,
        onSubmit: handleSubmit(onSubmit),
    }
}

export default useExportContactDetails;